import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d1d6f74&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1d6f74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/business/yq-monitor-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d1d6f74')) {
      api.createRecord('6d1d6f74', component.options)
    } else {
      api.reload('6d1d6f74', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6d1d6f74&scoped=true&", function () {
      api.rerender('6d1d6f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-view/components/digital-flipper/index.vue"
export default component.exports